<template>
  <a @click="changeState" class="nuttrema-show-hide-button">
    {{ state ? $t('label.hide_details') : $t('label.show_details') }} <i :class="[state ? iconUp : iconDown]"></i>
  </a>
</template>

<script>
export default {
  name: 'nuttrema-show-hide-button',
  props: {
    state: {
      type: Boolean,
      required: true,
      default: null,
    },
    iconUp: {
      type: String,
      required: false,
      default: 'far fa-angle-up',
    },
    iconDown: {
      type: String,
      required: false,
      default: 'far fa-angle-down',
    },
  },
  methods: {
    changeState() {
      this.$emit('update:state', !this.state);
    },
  },
};
</script>

<style lang="scss" scoped>
  .nuttrema-show-hide-button {
    i {
      margin-left: 0.5em;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/button/nuttrema-show-hide-button.vue